import { ChevronIcon } from 'assets/icons';
import { ErrorMessage } from 'components/Form/components/ErrorMessage';
import * as SField from 'components/Form/components/Field/field.styles';
import { composeValidators } from 'components/Form/validate';
import { Message } from 'models';
import React, { ChangeEventHandler } from 'react';
import { Field } from 'react-final-form';
import { ContentUtil } from 'utils/content';
import { v4 as uuid } from 'uuid';

import { content } from './select.content';
import * as S from './select.styles';

const contentUtil = new ContentUtil({ content, componentName: 'Form > Select' });

interface SelectOptionsProps {
  defaultSelectValue?: boolean;
  defaultSelectLabel?: string;
  options: { value: string; label: string; default?: boolean; id?: string }[];
}

export interface SelectProps extends SelectOptionsProps {
  name: string;
  label?: string;
  ariaLabel?: string;
  hideLabel?: boolean;
  id?: string;
  onChange?: ChangeEventHandler<HTMLSelectElement>;
  disabled?: boolean;
  isRequired?: boolean;
  validate?: Array<(inputValue: unknown) => undefined | Message>;
  variant?: string;
  testid?: string;
}

const SelectOptions = (props: SelectOptionsProps) => {
  return (
    <React.Fragment>
      {props.defaultSelectValue && (
        <option value="" disabled>
          {props.defaultSelectLabel}
        </option>
      )}
      {props.options &&
        props.options.length &&
        props.options.map((option, index) => (
          <option value={option.value} key={index} id={option.id}>
            {option.label}
          </option>
        ))}
    </React.Fragment>
  );
};

export class Select extends React.Component<SelectProps, object> {
  onFieldChange = (e: React.ChangeEvent<HTMLSelectElement>, FFonFieldChange: ChangeEventHandler<HTMLSelectElement>) => {
    FFonFieldChange(e);
    if (typeof this.props.onChange === 'function') this.props.onChange(e);
  };

  render() {
    const {
      name,
      variant,
      options,
      label,
      hideLabel,
      ariaLabel,
      isRequired,
      validate,
      id = uuid(),
      disabled,
      defaultSelectValue = true,
      defaultSelectLabel = contentUtil.translateToString('defaultOption'),
      testid,
    } = this.props;

    return (
      <React.Fragment>
        {label && (
          <S.Label htmlFor={id}>
            {label} {isRequired && <span> *</span>}
          </S.Label>
        )}
        <Field
          name={name}
          validate={validate ? composeValidators(validate) : undefined}
          render={({ input, meta }) => {
            const select = (
              <S.Select
                {...input}
                value={
                  typeof input.value === 'string' || typeof input.value === 'number' || Array.isArray(input.value)
                    ? input.value
                    : ''
                }
                data-testid={testid}
                variant={variant}
                aria-label={hideLabel ? label : ariaLabel}
                onChange={(e) => this.onFieldChange(e, input.onChange)}
                disabled={disabled}
                id={id}>
                <SelectOptions
                  defaultSelectValue={defaultSelectValue}
                  defaultSelectLabel={defaultSelectLabel}
                  options={options}
                />
              </S.Select>
            );

            return (
              <React.Fragment>
                {variant === 'sort' && select}
                {variant !== 'sort' && (
                  <SField.Field>
                    {select}
                    <S.Chevron>
                      <ChevronIcon />
                    </S.Chevron>
                  </SField.Field>
                )}
                {meta.error && meta.touched && <ErrorMessage message={meta.error} />}
              </React.Fragment>
            );
          }}
        />
      </React.Fragment>
    );
  }
}
